import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/shared/services/common/common.service';

@Component({
  selector: 'app-store-privacy-and-policy',
  templateUrl: './store-privacy-and-policy.component.html',
  styleUrls: ['./store-privacy-and-policy.component.css']
})
export class StorePrivacyAndPolicyComponent implements OnInit {

  PrivacyContent: any;
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.fn_GetPrivacyPolicy();
  }

  fn_GetPrivacyPolicy() {
    this.commonService.getPrivacyPolicyAndTermsofUse().subscribe((res: any) => {
      if (res.StatusCode === 200) {        
        if (res.Data.ResponseData != null) {
            this.PrivacyContent = res.Data.ResponseData[0];
        }
      }
    }, (err: any) => {
    });
  }

}
